import { type Resolver, schemaUserCategories, teamCategory } from 'cpool-schemas';
import { z } from 'zod';

import { defaultDBValues } from '../../../../util/defaultDBValues';
import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    leadDetails?: boolean;
    position?: number;
};
// we need to override the antragsteller1 field to be required as this resolver already checks if it exists
export const schemaLoanRequestResolver_Get = LoanRequestsTableDefinitionZod.omit({ antragsteller1: true }).merge(
    z
        .object({
            antragsteller1: LoanRequestsTableDefinitionZod.shape.antragsteller1.unwrap(),
            nextIKCategory: teamCategory.optional(),
            userCategories: schemaUserCategories.optional(),
        })
        .merge(defaultDBValues),
);

export type SchemaLoanRequestResolver_Get = z.infer<typeof schemaLoanRequestResolver_Get>;

export type LoanRequestResolver_Get = Resolver<Arguments, SchemaLoanRequestResolver_Get>;
